import React from 'react';
import pic0 from './pic0.jpg';
import pic1 from './pic1.jpg';
import pic3 from './pic3.jpg';

const CompanySection = () => {
  return (
    <section className="section" id="company">
      <div className="section-scroll">
        <div className="section-container">
          <header className="section-heading">
            <div>
              <span className="section-kicker">Built for the road ahead</span>
              <h2>Logistics with a<br /><em>human touch.</em></h2>
            </div>
            <p>
              We pair industry experience with personal service to move freight
              efficiently, transparently and on time.
            </p>
          </header>

          <div className="company-showcase">
            <div className="company-gallery">
              <div className="company-image">
                <img src={pic3} alt="GOS Trans truck ready for the road" />
                <div className="image-label"><span>Based in</span><strong>Naperville, IL</strong></div>
              </div>
              <div className="company-thumbs">
                <figure>
                  <img src={pic0} alt="GOS Trans fleet lined up" />
                  <figcaption>Our fleet</figcaption>
                </figure>
                <figure>
                  <img src={pic1} alt="GOS Trans tractor unit" />
                  <figcaption>On the road</figcaption>
                </figure>
              </div>
            </div>
            <div className="company-values">
              <article className="company-subsection">
                <span className="card-number">01</span>
                <h3>What we do</h3>
                <p>
                  GOS TRANS is a leading freight dispatching and logistics coordination company.
                  We connect brokers and shippers with reliable service, ensuring efficient and
                  timely delivery of goods across the United States.
                </p>
                <p>
                  Our services include freight dispatching, route optimization, real-time
                  tracking, and logistics management tailored to each client.
                </p>
              </article>

              <article className="company-subsection">
                <span className="card-number">02</span>
                <h3>Our journey</h3>
                <p>
                  Founded with a vision to improve transportation, GOS TRANS has grown from a
                  local operation into a trusted partner for businesses nationwide.
                </p>
                <p>
                  Strong relationships with brokers and shippers have earned us a reputation
                  for reliability, transparency, and exceptional service.
                </p>
              </article>

              <article className="company-subsection">
                <span className="card-number">03</span>
                <h3>Our promise</h3>
                <p>
                  We build lasting partnerships based on trust, integrity, and mutual success.
                  Our experienced team provides personal solutions that exceed expectations.
                </p>
                <p>
                  We combine technology and expertise to solve modern logistics challenges and
                  deliver results that drive your business forward.
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanySection;
